/** Template lifecycle state strings — use these instead of bare string literals. */
export const TEMPLATE_STATES = {
  DRAFT: "Draft",
  PUBLISHED: "Published",
} as const;

export type TemplateState = (typeof TEMPLATE_STATES)[keyof typeof TEMPLATE_STATES];

/** Well-known folder names — use these instead of bare string literals. */
export const FOLDER_NAMES = {
  DRAFTS: "Drafts",
  DEMO_TEMPLATES: "DemoTemplates",
} as const;

/** UI category labels that map to API category values. */
export const CATEGORY_LABELS = {
  GLOBAL: "Global",
  ACCOUNT: "Account",
  CLIENT: "Client",
} as const;

export type CategoryLabel = (typeof CATEGORY_LABELS)[keyof typeof CATEGORY_LABELS];

/** S3 upload constants — platform ID for metadata in presigned URLs. */
export const S3_CONSTANTS = {
  PLATFORM_ID: "AIDE_0082245",
} as const;
